const m = require("air-vue-model")();
m.url = "yandex_eda";
m.name = "yandexEda";

module.exports = m;
